/*
 * Copyright (c) 2026, FusionAuth, All Rights Reserved
 */

// @ts-ignore vite env
const devMode = import.meta.env.DEV;

/**
 * A development-only logger.
 *
 * In production builds Vite replaces `import.meta.env.DEV` with `false`, so
 * `logger` is assigned the no-op object. Rollup then eliminates every call site
 * as dead code — nothing from this module survives in the production bundle.
 *
 * In development (`vite dev` / `vite build --mode development`) the real
 * implementation is used and logs appear in the browser console.
 *
 * Note: `vite build --watch` (used by `sb js-watch`) is a *production* watch
 * build — `import.meta.env.DEV` is false and logs are silent. Use `npm run dev`
 * to get live logs during development.
 */
export const logger = devMode
  ? {
      log(...args: any[]) {
        console.log(...args);
      },

      /**
       * Throttled log: fires at most once per `ms` ms for a given `key`.
       * First call for a key logs immediately; subsequent calls within the
       * window are suppressed. The window resets on each call.
       */
      logEvery: (() => {
        const timers = new Map<string, ReturnType<typeof setTimeout>>();
        return (ms: number, key: string, ...args: any[]) => {
          if (!timers.has(key)) {
            console.log(...args);
          }
          clearTimeout(timers.get(key));
          timers.set(key, setTimeout(() => timers.delete(key), ms));
        };
      })()
    }
  : {
      // Production no-ops — Rollup eliminates all call sites as dead code.
      log(..._args: any[]) {},
      logEvery(_ms: number, _key: string, ..._args: any[]) {}
    };

if (devMode) {
  logger.log('DEV mode, logs are live');
}
